window.jsSocials = {
	shares: {}
};

require('jssocials/src/jssocials.shares.js');

var SocialShare = function(){
	var self = this;
	this.jsSocials = [];

	$(".social-share").each(function(_,share){
		if(!jsSocials.shares[$(share).data("share")])
		{
			return;
		}
		share.href = jsSocials.shares[$(share).data("share")].shareUrl.replace(/\{url\}/, window.location.href);

		share.href = share.href.replace("&text={text}", "");
		share.href = share.href.replace("&via={via}", "");
		share.href = share.href.replace("&hashtags={hashtags}", "");

		$(share).on("click", function(e){
			e.preventDefault();

			var label = window.location.href.split("/").pop();

	        gtag('event', 'Social', {
	          eventAction: $(this).data("share"),
	          eventLabel: label ? label : "Homepage",
	          eventValue: 1
	        });

			window.open(this.href,null,"width=600,height=400");
		});
	});
};

module.exports = SocialShare;
